<template>
  <div>
    <header>
      <top-menu />
    </header>
    <section class="container-fluid p-0">
      <slot />
    </section>
  </div>
</template>
<script>
import TopMenu from "./TopMenu.vue";
export default {
  components: {
    TopMenu
  }
};
</script>
